module.exports = __webpack_public_path__ + "media/images/arrow2-e6c9ba689e15f8093a6465c68f2efe41.svg";